<div [formGroup]="form">
	<h1 mat-dialog-title>{{ data.titleKey | translate }}</h1>
	<div mat-dialog-content>
		<div class="ob-grid">
			<div class="ob-span-4">
				<mat-form-field>
					<mat-label>{{ "i18n.property.type" | translate }}</mat-label>
					<input matInput type="text" formControlName="type" id="edit-annotation-type" />
				</mat-form-field>
			</div>
			<div class="ob-span-4">
				<mat-form-field>
					<mat-label>{{ "i18n.property.title" | translate }}</mat-label>
					<input matInput type="text" formControlName="title" id="edit-annotation-title" />
				</mat-form-field>
			</div>

			<div class="ob-span-4">
				<mat-form-field>
					<mat-label>{{ "i18n.property.identifier" | translate }}</mat-label>
					<input matInput type="text" formControlName="identifier" id="edit-annotation-identifier" />
				</mat-form-field>
			</div>
		</div>

		@for (lang of data.contentLanguages; track lang) {
			<mat-form-field formGroupName="text">
				<mat-label>{{ "i18n.property.text" | translate }} ({{ lang | uppercase }})</mat-label>
				<textarea formControlName="{{ lang }}" matInput id="edit-annotation-text-{{ lang }}"></textarea>
			</mat-form-field>
		}

		<mat-form-field>
			<mat-label>{{ "i18n.property.uri" | translate }}</mat-label>
			<input type="text" matInput formControlName="uri" id="edit-annotation-uri" />
			@if (form.get("uri")?.errors?.pattern) {
				<mat-error>
					{{ "i18n.error.uri_pattern" | translate }}
				</mat-error>
			}
		</mat-form-field>
	</div>

	<div mat-dialog-actions>
		<button
			type="button"
			id="edit-annotation-cancel-button"
			mat-button
			obButton="tertiary"
			matTooltip=" {{ 'i18n.tooltip.cancel' | translate }}"
			mat-dialog-close
		>
			{{ "i18n.button.cancel" | translate }}
		</button>
		<button
			mat-button
			type="button"
			id="edit-annotation-save-button"
			obButton="primary"
			matTooltip=" {{ 'i18n.tooltip.save' | translate }}"
			(click)="safeClick()"
			cdkFocusInitial
			[disabled]="disableSave"
		>
			{{ "i18n.button.save" | translate }}
		</button>
	</div>
</div>
